import { render, staticRenderFns } from "./PageLayout.vue?vue&type=template&id=32843fb5&scoped=true"
import script from "./PageLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./PageLayout.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PageLayout.vue?vue&type=style&index=0&id=32843fb5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32843fb5",
  null
  
)

export default component.exports